import React, { useState, useEffect } from "react";
import "../../styles/bannerSection.css";
import { faStar } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import * as Config from "../../lib/config";
import Image from "../../components/Image";
import { FadeLeftAnimate } from "../../components/animateEffect/Fade";
import { Link as ScrollLink } from "react-scroll";

const BannerSection = () => {
  const textVariations = [
    "Download Free AR Drawing App",
    "Join 20M+ Artists"
  ];
  const [currentTextIndex, setCurrentTextIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentTextIndex((prevIndex) => (prevIndex + 1) % textVariations.length);
    }, 3000);
    return () => clearInterval(interval);
  }, [textVariations.length]);
  return (
    <div className="section4Container">
      <div className="container sectionVerticalSpace2">
        <div className="row justify-content-center ">
          <div className="col-lg-8 text-center  ">
            <FadeLeftAnimate>
           
              <h1><span className="brandCharName brandName">AR Drawing
                </span> - Sketch & Paint Anything with Your Phone</h1>
              <p className="">
            Sketch, Paint, and Create Anything you can imagine using our advanced AR Drawing app.
Choose from 20,000+ AR drawing templates and customize instantly. 
              </p>

              <div className="text-3d-container">
                <p className="text-center font-weight-bolder download-now-btn2 text-3d-transform">
                  {textVariations[currentTextIndex]}
                </p>
              </div>
            </FadeLeftAnimate>
              <div className="download-buttons mb-4">
              <a
                target="_blank"
                rel="noreferrer"
                href={Config.IphoneLink}
              >
                <Image
                  src={Config.images.appstore}
                  alt="Download on the App Store"
                  width="150"
                  height="50"
                  className="shareIcons"
                  loading="lazy"
                />
              </a>
              <a
                target="_blank"
                rel="noreferrer"
                href={Config.AndroidLink}
              >
                <Image
                  src={Config.images.playstore}
                  alt="Download on Google Play"
                  width="150"
                  height="50"
                  className="shareIcons"
                  loading="lazy"
                />
              </a>
               </div>
            <div className="user-rating mb-2 d-flex justify-content-center">
              {/* <!-- Repeat for each user image --> */}
              <div className="pr-3">
                <Image
                  src={Config.personProfile.profile1}
                  alt="User profile image"
                  width="40"
                  height="40"
                  className="personProfiles"
                  loading="lazy"
                />
                <Image
                  src={Config.personProfile.profile2}
                  alt="User profile image"
                  width="40"
                  height="40"
                  className="personProfiles"
                  loading="lazy"
                />
                <Image
                  src={Config.personProfile.profile3}
                  alt="User profile image"
                  width="40"
                  height="40"
                  className="personProfiles"
                  loading="lazy"
                />
                <Image
                  src={Config.personProfile.profile4}
                  alt="User profile image"
                  width="40"
                  height="40"
                  className="personProfiles"
                  loading="lazy"
                />
                <Image
                  src={Config.personProfile.profile5}
                  alt="User profile image"
                  width="40"
                  height="40"
                  className="personProfiles"
                  loading="lazy"
                />
              </div>
              {/* <!-- Star icons --> */}
         
              <ScrollLink
                to="Reviews"
                smooth={true}
                duration={500}
                className="d-flex align-items-center cursor-pointer"
                style={{ cursor: 'pointer' }}
              >
                <FontAwesomeIcon icon={faStar} className="fa-star" />
                <FontAwesomeIcon icon={faStar} className="fa-star" />
                <FontAwesomeIcon icon={faStar} className="fa-star" />
                <FontAwesomeIcon icon={faStar} className="fa-star" />
                <FontAwesomeIcon icon={faStar} className="fa-star" />
              </ScrollLink>
            </div>
            <p>
              Rated 4.9/5.0 With Over 20m+ Users Are Designing Drawing Using The AR Drawing App.

            </p>
            
       
          
                      <div className="col-12 p-0 mt-4 d-flex justify-content-center align-items-center ">
              <div className="dwonloadSection row m-0 col-12 pb-4 ">
                <div className="col-3 p-0 d-flex align-items-center justify-content-center">
                  <Image
                    src={Config.images.appIcon}
                    alt="AR Drawing App Icon"
                    width="130"
                    height="130"
                    className="rounded-4"
                    loading="eager"
                    fetchpriority="high"
                  />
                </div>
                <div className="col-9 d-flex flex-column justify-content-center pr-0 pr-md-3">
                  <h3 style={{ fontSize: '28px', fontWeight: 'bold' }}>AR Drawing - AR Sketch App</h3>
                  <p style={{ fontSize: '20px', color: '#555', marginBottom: '10px' }}>Trace & Draw Picture on Paper</p>
                  <a href={Config.IphoneLink} target="_blank" rel="noreferrer" className="btn text-white download-now-btn">
                    Download Now
                  </a>
                </div>
              </div>
            </div>
              {/* <a target="_blank" rel="noreferrer" href="">
                <Image
                  src={Config.images.websiteLogo}
                  alt="Available as Website"
                  width="150"
                  height="50"
                  className="shareIcons"
                  loading="lazy"
                />
              </a> */}
           

            <div className="col-12 col-md-9 p-0 ">
              {/* <div className="qr-code row w-100 col-12 m-0">
                <div className="col-3 p-0 d-flex align-items-center">
                  <PulseAnimate>
                    <QRCode
                      size={256}
                      style={{ height: "auto", maxWidth: "100%", width: "100%" }}
                      value={Config.IphoneLink}
                      viewBox={`0 0 256 256`}
                    />
                  </PulseAnimate>
                </div>
                <div className="col-9">
                  <p className="downloadTitle">Download or Fall Behind!</p>
                  <p className="downloadSubTitle">
                    Unlock the app's magic with a simple scan. Dive into
                    exclusive content. Download now and dive in!
                  </p>
                </div>
              </div> */}
            </div>
          </div>
          {/* <div className="col-lg-4 pt-4 pt-md-0">
            <div className="">
              <RedirectLink>
                <div className="flyer-example slick_Arrow sketchSlider ">
                  <CustomSlider settings={Settings}>
                    {sliderBanner.map((banner, index) => (
                      <>
                        <Image
                          key={index}
                          src={banner}
                          alt="Example AR Drawing image with text 'BAKE SALE - PIES, CAKES, COOKIES & MORE' and a discount offer /"
                          width="300"
                          height="400"
                          className="rounded-2"
                          loading={index === 0 ? "eager" : "lazy"}
                          fetchpriority={index === 0 ? "high" : "auto"}
                        />
                      </>
                    ))}
                  </CustomSlider>
                </div>
              </RedirectLink>
            </div>
          </div> */}
        </div>
      </div>
    </div>
  );
};

export default BannerSection;
